<script setup lang="ts">
import type { HTMLAttributes, MaybeRef } from 'vue'
import { cn } from '@scripts/utils.js'

interface AnimationOptions {
    paused: MaybeRef<boolean>
    duration: number
}

const {
    value = 0,
    variant = 'default',
    animate = false,
    ...props
} = defineProps<{
    value?: number
    variant?: 'default' | 'transparent'
    class?: HTMLAttributes['class']
    animate?: boolean | AnimationOptions
}>()
</script>

<template>
    <div
        :class="
            cn(
                {
                    'bg-stone-200': variant === 'default',
                    'bg-black/80': variant === 'transparent',
                    'animate-progress': animate !== false,
                },
                'h-1 overflow-hidden rounded-full md:w-48',
                props.class
            )
        "
        :style="
            animate === false
                ? {
                      '--progress': value,
                  }
                : {
                      animationDuration: `${animate.duration}ms`,
                      animationPlayState: animate.paused ? 'paused' : 'running',
                  }
        "
    >
        <div
            class="relative block h-full w-full translate-x-(--indicator-progress) rounded-full"
            :class="{
                'bg-stone-400': variant === 'default',
                'bg-white': variant === 'transparent',
            }"
            :style="{
                '--indicator-progress':
                    'calc((100 - var(--progress, 0)) * -1%)',
            }"
        />
    </div>
</template>
